require('@babel/polyfill');

require('lodash');
require('angular');
require('angular-ellipsis');
require('angular-animate');

require('bootstrap/dist/css/bootstrap.css');
require('font-awesome/css/font-awesome.css');

require('../../vendor/currency-filter-2.1.0.vendor.js');
require('../../vendor/isoCurrency.min.vendor.js');

require('../../vendor/ui-bootstrap-tpls-2.3.0.vendor.js');
require('../../vendor/xml2json.vendor.js');

require('../../vendor/jsbn/base64.vendor.js');
require('../../vendor/jsbn/prng4.vendor.js');
require('../../vendor/jsbn/jsbn.vendor.js');
require('../../vendor/jsbn/rng.vendor.js');
require('../../vendor/jsbn/rsa.vendor.js');

require('../../vendor/angular-ui-notification.vendor.js');
require('../../vendor/angular-ui-notification.vendor.css');

require('summernote/dist/summernote.css');
require('summernote/dist/summernote.js');

if (module.hot) {
    module.hot.accept();

    window.addEventListener('message', e => {
        if ('production' !== process.env.NODE_ENV) {
            // console.clear();
        }
    });
}

const i18next = require('i18next');
const i18nLanguageDetector = require('i18next-browser-languagedetector');

i18next
    .use(i18nLanguageDetector)
    .init({
        detection: {},
        debug: true,
        lng: 'en-US',
        nsSeparator: '|'
    });

const uirouter = require('@uirouter/angularjs');
require('@uirouter/angularjs/release/stateEvents');
const ngCookies = require('angular-cookies');
require('angular-readable-time');
const angularFileSaver = require('angular-file-saver');
const uiBootstrap = require('angular-ui-bootstrap');
const angularSanitize = require('angular-sanitize');
const ngIdle = require('ng-idle');
const uiSelect = require('ui-select');
const relativeDate = require('angular-relative-date');

angular.module('umCore', [
    angularSanitize,
    'ngAnimate',
    ngIdle,
    uirouter.default,
    ngCookies,
    uiBootstrap,
    uiSelect,
    relativeDate.default.name,
    'ui-notification',
    'currencyFilter',
    'isoCurrency',
    'dibari.angular-ellipsis',
    'readableTime',
    'umFormViewer',
    'umUser',
    angularFileSaver,
    'ui.router.state.events'
]).config(function (NotificationProvider) {
    NotificationProvider.setOptions({
        verticalSpacing: 0,
        horizontalSpacing: 30
    });
})
    .run(function () {});

require('./coreMediator');
require('./coreConstant');
require('./core.less');
require('./vendors.less');

require('./attachment/attachmentMediator');
require('./attachment/repository/attachmentEmailsRepository');
require('./attachment/repository/attachmentRepository');
require('./attachment/repository/deleteAttachmentRepository');
require('./attachment/repository/saveAttachmentRepository');
require('./attachment/repository/updateAttachmentRepository');

require('./constants/submissionConstant');

// require('./decorators/inputDecorator');
// require('./decorators/uibTooltipDecorator');
// require('./decorators/uiSelectDirectiveDecorator');

require('./directives/appModeConfiguration');
require('./directives/peoplePickerSaveOnBlurDirective');
require('./directives/uiAutoClose');
require('./directives/uiAutoExpand');
require('./directives/uiAutoFocus');
require('./directives/uiBrowserDetection');
require('./directives/uiCustomOnChange');
require('./directives/uiDropdownFitToWindow');
require('./directives/uiDropZone');
require('./directives/uiEnter');
require('./directives/uiErrorHandler');
require('./directives/uiExternalHrefTargetBlankDirective');
require('./directives/uiFocusManager');
require('./directives/uiHideSelectOnScrollDirective');
require('./directives/uiIsTooltipEnabled');
require('./directives/uiLogo');
require('./directives/uiMaxChars');
require('./directives/uiModalNotificationHandler');
require('./directives/uiReloadRelativeTime');
require('./directives/uiResponsiveViewport');
require('./directives/uiRestrict');
require('./directives/uiScrollDetection');
require('./directives/uiScrollToBottom');
require('./directives/uiScrollToItem');
require('./directives/uiCustomPrintTitle');
require('./directives/uiSetFocus');
require('./directives/uiStickyElement');
require('./directives/uiSystemFont');
require('./directives/uiUpload');
require('./directives/formatters/uiCurrencyFormatter');
require('./directives/formatters/uiDatetimeFormatter');
require('./directives/formatters/uiNumberWithCommasFormatter');
require('./directives/formatters/uiNumberWithoutCommasFormatter');
require('./directives/formatters/uiPercentFormatter');
require('./directives/formatters/uiPhoneNumberFormatter');
require('./directives/formatters/uiZipCodeFormatter');

require('./filters/emailRecipientsFilter');
require('./filters/nl2brFilter');
require('./filters/utcDateFilter');

require('./formViewer/formViewerModule');
require('./formViewer/formViewerDirective');
require('./formViewer/formViewerController');
require('./formViewer/formViewerConstant');
require('./formViewer/formMediator');
require('./formViewer/formViewerUtil');
require('./formViewer/formViewer.tpl.html');

require('./formViewer/component/baseDataSetFormComponentController');
require('./formViewer/component/baseFormComponentController');
require('./formViewer/component/formComponentUtil');
require('./formViewer/component/formPlaceholder.tpl.html');
require('./formViewer/component/sectionPlaceholder.tpl.html');
require('./formViewer/component/supplementalFormPlaceholder.tpl.html');

require('./formViewer/component/calendar/calendar.tpl.html');
require('./formViewer/component/calendar/calendarComponent');
require('./formViewer/component/calendar/calendarController');
require('./formViewer/component/calendar/calendarPlaceholder.tpl.html');
require('./formViewer/component/calendar/calendarPopover.tpl.html');
require('./formViewer/component/calendar/uiCalendarAutoClose');

require('./formViewer/component/checkbox/checkbox.tpl.html');
require('./formViewer/component/checkbox/checkboxComponent');
require('./formViewer/component/checkbox/checkboxController');
require('./formViewer/component/checkbox/checkboxPlaceholder.tpl.html');

require('./formViewer/component/checkboxGroup/checkboxGroup.tpl.html');
require('./formViewer/component/checkboxGroup/checkboxGroupComponent');
require('./formViewer/component/checkboxGroup/checkboxGroupController');
require('./formViewer/component/checkboxGroup/checkboxGroupPlaceholder.tpl.html');

require('./formViewer/component/multiSelect/multiSelect.tpl.html');
require('./formViewer/component/multiSelect/multiSelectComponent');
require('./formViewer/component/multiSelect/multiSelectController');
require('./formViewer/component/multiSelect/multiSelectPlaceholder.tpl.html');

require('./formViewer/component/classCode/classCode.tpl.html');
require('./formViewer/component/classCode/classCodeComponent');
require('./formViewer/component/classCode/classCodeController');
require('./formViewer/component/classCode/classCodePlaceholder.tpl.html');
require('./formViewer/component/classCode/classCodePopulateSearchTextDirective');
require('./formViewer/component/classCode/classCodeStopEventDirective');

require('./formViewer/component/multiSelectClassCode/multiSelectClassCode.tpl.html');
require('./formViewer/component/multiSelectClassCode/multiSelectClassCodeComponent');
require('./formViewer/component/multiSelectClassCode/multiSelectClassCodeController');

require('./formViewer/component/directive/uiCalendarFocus');
require('./formViewer/component/directive/uiClickOutside');
require('./formViewer/component/directive/uiFormTooltip');
require('./formViewer/component/directive/uiManualSize');
require('./formViewer/component/directive/uiNextRequiredFieldFinder');
require('./formViewer/component/directive/uiOverflowTooltip');
require('./formViewer/component/directive/uiPopupPosition');
require('./formViewer/component/directive/uiRemoteChangeNotification');
require('./formViewer/component/directive/uiScrollIntoView');
require('./formViewer/component/directive/uiSnippetsIndicator');
require('./formViewer/component/directive/uiTooltip');

require('./formViewer/component/directive/uiHiddenFieldDetailsModal/hiddenDetailsModalController');
require('./formViewer/component/directive/uiHiddenFieldDetailsModal/hiddenFieldDetailsModal.less');
require('./formViewer/component/directive/uiHiddenFieldDetailsModal/hiddenFieldDetailsModal.tpl.html');
require('./formViewer/component/directive/uiHiddenFieldDetailsModal/uiShowHiddenFieldDetailsModal');

require('./formViewer/component/directive/uiShowFieldDetailsModal/fieldDetailsModal.tpl.html');
require('./formViewer/component/directive/uiShowFieldDetailsModal/fieldDetailsModalController');
require('./formViewer/component/directive/uiShowFieldDetailsModal/uiShowFieldDetailsModal');

require('./formViewer/component/dropdown/formDropdownComponent');
require('./formViewer/component/dropdown/formDropdown.tpl.html');
require('./formViewer/component/dropdown/formDropdownController');
require('./formViewer/component/dropdown/formDropdownHandleActiveIndexDirective');
require('./formViewer/component/dropdown/formDropdownHandleFocusDirective');
require('./formViewer/component/dropdown/formDropdownPlaceholder.tpl.html');
require('./formViewer/component/dropdown/formDropdownUnselectItemDirective');

require('./formViewer/component/fieldList/fieldList.tpl.html');
require('./formViewer/component/fieldList/fieldListComponent');
require('./formViewer/component/fieldList/fieldListController');

require('./formViewer/component/formSummary/deleteFormSummaryInstanceRepository');
require('./formViewer/component/formSummary/formSummaryButtonPositionDirective');
require('./formViewer/component/formSummary/formSummaryGrid.tpl.html');
require('./formViewer/component/formSummary/formSummaryGridComponent');
require('./formViewer/component/formSummary/formSummaryGridController');
require('./formViewer/component/formSummary/formSummaryGridPlaceholder.tpl.html');
require('./formViewer/component/formSummary/formSummaryRepository');
require('./formViewer/component/formSummary/detail/formSummaryGridDetail.tpl.html');
require('./formViewer/component/formSummary/detail/formSummaryGridDetailController');

require('./formViewer/component/functionButton/buttonPlaceholder.tpl.html');
require('./formViewer/component/functionButton/functionButton.tpl.html');
require('./formViewer/component/functionButton/functionButtonComponent');
require('./formViewer/component/functionButton/functionButtonController');
require('./formViewer/component/functionButton/functionButtonPlaceholder.tpl.html');

require('./formViewer/component/label/label.less');
require('./formViewer/component/label/label.tpl.html');
require('./formViewer/component/label/labelComponent');
require('./formViewer/component/label/labelController');
require('./formViewer/component/label/labelPlaceholder.tpl.html');

require('./formViewer/component/radioButtonGroup/radioButtonGroup.tpl.html');
require('./formViewer/component/radioButtonGroup/radioButtonGroupComponent');
require('./formViewer/component/radioButtonGroup/radioButtonGroupController');
require('./formViewer/component/radioButtonGroup/radioButtonGroupPlaceholder.tpl.html');

require('./formViewer/component/requiredIndicatorLabel/requiredIndicatorLabel.tpl.html');
require('./formViewer/component/requiredIndicatorLabel/requiredIndicatorLabelComponent');
require('./formViewer/component/requiredIndicatorLabel/requiredIndicatorLabelController');

require('./formViewer/component/rowRepeater/rowRepeater.tpl.html');
require('./formViewer/component/rowRepeater/rowRepeaterComponent');
require('./formViewer/component/rowRepeater/rowRepeaterController');
require('./formViewer/component/rowRepeater/rowRepeaterPlaceholder.tpl.html');

require('./formViewer/component/rowRepeater/header/columnHeader.tpl.html');
require('./formViewer/component/rowRepeater/header/columnHeaderComponent');
require('./formViewer/component/rowRepeater/header/columnHeaderController');

require('./formViewer/component/rowRepeater/paging/paging.tpl.html');
require('./formViewer/component/rowRepeater/paging/pagingComponent');
require('./formViewer/component/rowRepeater/paging/pagingController');

require('./formViewer/component/rowRepeater/repeatingRows/repeatingRowsDirective');

require('./formViewer/component/rowRepeater/repo/addFormRowRepository');
require('./formViewer/component/rowRepeater/repo/deleteFormRowRepository');

require('./formViewer/component/spacer/spacer.tpl.html');
require('./formViewer/component/spacer/spacerComponent');
require('./formViewer/component/spacer/spacerController');
require('./formViewer/component/spacer/spacerPlaceholder.tpl.html');

require('./formViewer/component/textarea/textArea.tpl.html');
require('./formViewer/component/textarea/textAreaComponent');
require('./formViewer/component/textarea/textAreaController');
require('./formViewer/component/textarea/textAreaPlaceholder.tpl.html');

require('./formViewer/component/textInput/textInput.tpl.html');
require('./formViewer/component/textInput/textInputComponent');
require('./formViewer/component/textInput/textInputController');
require('./formViewer/component/textInput/textInputPlaceholder.tpl.html');

require('./formViewer/component/uploadAttachment/uploadAttachment.i18n.json');
require('./formViewer/component/uploadAttachment/uploadAttachment.tpl.html');
require('./formViewer/component/uploadAttachment/uploadAttachmentComponent');
require('./formViewer/component/uploadAttachment/uploadAttachmentController');
require('./formViewer/component/uploadAttachment/uploadAttachmentPlaceholder.tpl.html');

require('./formViewer/component/urlLink/urlLink.tpl.html');
require('./formViewer/component/urlLink/urlLinkComponent');
require('./formViewer/component/urlLink/urlLinkController');
require('./formViewer/component/urlLink/urlLinkPlaceholder.tpl.html');


require('./formViewer/component/yesNoRadio/yesNoRadio.tpl.html');
require('./formViewer/component/yesNoRadio/yesNoRadioComponent');
require('./formViewer/component/yesNoRadio/yesNoRadioController');
require('./formViewer/component/yesNoRadio/yesNoRadioPlaceholder.tpl.html');

require('./formViewer/editor/componentEditor.i18n.json');

require('./formViewer/editor/componentEditor.tpl.html');
require('./formViewer/editor/componentEditorComponent');
require('./formViewer/editor/componentEditorController');
require('./formViewer/editor/componentEditorPlaceholder.tpl.html');
require('./formViewer/editor/componentModel');
require('./formViewer/editor/dragModel');
require('./formViewer/editor/getUiFieldListRepository');

require('./formViewer/editor/directives/uiColumnResize');
require('./formViewer/editor/directives/uiDraggableColumn');
require('./formViewer/editor/directives/uiDragManager');

require('./formViewer/editor/row/rowEditor.i18n.json');
require('./formViewer/editor/row/rowEditor.tpl.html');
require('./formViewer/editor/row/rowEditorComponent');
require('./formViewer/editor/row/rowEditorController');
require('./formViewer/editor/row/rowEditorPlaceholder.tpl.html');
require('./formViewer/editor/row/uiDraggableRow');
require('./formViewer/editor/section/sectionEditor.i18n.json');
require('./formViewer/editor/section/sectionEditor.tpl.html');
require('./formViewer/editor/section/sectionEditorComponent');
require('./formViewer/editor/section/sectionEditorController');
require('./formViewer/editor/section/sectionEditorPlaceholder.tpl.html');
require('./formViewer/editor/section/uiDraggableSection');

require('./formViewer/functions/remoteFunction');

require('./formViewer/model/delayShowNextRequiredFieldModel');
require('./formViewer/model/formConfigurationUtil');
require('./formViewer/model/formRegistrationModel');
require('./formViewer/model/formStructureUtil');
require('./formViewer/model/formViewerModel');
require('./formViewer/model/rowRepeaterRowListComparisonResultConstant');
require('./formViewer/model/rowRepeaterUtil');
require('./formViewer/model/supplementalFormUtil');

require('./formViewer/rendering/formComponentRenderingUtil');
require('./formViewer/rendering/formRenderingUtil');
require('./formViewer/rendering/uiViewportManager');
require('./formViewer/rendering/watchManagerUtil');

require('./formViewer/repo/addDeleteRepeatingFormConfigRepository');
require('./formViewer/repo/classCodeFormatRepository');
require('./formViewer/repo/classCodeRepository');
require('./formViewer/repo/classCodeItemsRepository');
require('./formViewer/repo/classCodeGroupingsRepository');
require('./formViewer/repo/closeFormRepository');
require('./formViewer/repo/createFieldInstanceRepository');
require('./formViewer/repo/formInstanceRepository');
require('./formViewer/repo/formRepository');
require('./formViewer/repo/formSnippetBlobRepository');
require('./formViewer/repo/formSnippetsRepository');
require('./formViewer/repo/formTemplateRepository');
require('./formViewer/repo/loadFieldInstanceListRepository');
require('./formViewer/repo/loadRowInstanceListRepository');
require('./formViewer/repo/loadRowInstanceRepository');
require('./formViewer/repo/remoteFunctionRepository');
require('./formViewer/repo/uiFormTemplateRepository');
require('./formViewer/repo/updateFieldInstanceRepository');

require('./formViewer/structure/repeatingRow/repeatingRow.tpl.html');
require('./formViewer/structure/repeatingRow/repeatingRowComponent');
require('./formViewer/structure/repeatingRow/repeatingRowController');
require('./formViewer/structure/repeatingRow/repeatingRowPlaceholder.tpl.html');

require('./formViewer/structure/row/row.tpl.html');
require('./formViewer/structure/row/rowComponent');
require('./formViewer/structure/row/rowController');
require('./formViewer/structure/row/rowPlaceholder.tpl.html');

require('./interceptors/errorInResponseInterceptor');

require('./localization/localization.js');
require('./localization/uiTranslate.js');
require('./localization/uiLocale.js');

require('./log/uiPerformanceLog/uiPerformanceLogger');
require('./log/uiPerformanceLog/uiPerformanceLoggerConstant');
require('./log/uiPerformanceLog/uiPerformanceLogRepository');
require('./log/logRepository');
require('./log/logUtil');
require('./log/umsLog');

require('./model/appTypeConfigurationModel');
require('./model/currentUserModel');
require('./model/gridColumnModel');
require('./model/navigationStateModel');
require('./model/preferenceModel');
require('./model/timingModel');

require('./repository/cachedDataSetsRepository');
require('./repository/chatRoomRepository');
require('./repository/currentUserProfileRepository');
require('./repository/dataSetRepository');
require('./repository/defaultPreferencesRepository');
require('./repository/deleteUserImageRepository');
require('./repository/getServerPublicKeySpecRepository');
require('./repository/loadProfileImageRepository');
require('./repository/loadUserDetailsRepository');
require('./repository/configuredFileRepository');
require('./repository/configuredFileDataRepository');
require('./repository/notificationEmailTemplateRepository');
require('./repository/notificationPopupTemplateRepository');
require('./repository/peoplePickerRepository');
require('./repository/registrationRepository');
require('./repository/repeatingFormDynamicDataSetFormSetIdRepository');
require('./repository/revisionRepository');
require('./repository/sendEmailNotificationRepository');
require('./repository/serverAckRepository');
require('./repository/umRevisionRepository');
require('./repository/updateUserPreferencesRepository');
require('./repository/updateUserProfileRepository');
require('./repository/userImageRepository');
require('./repository/userPreferencesRepository');
require('./repository/userProfileRepository');
require('./repository/base/baseCachedRepository');
require('./repository/base/baseCachedSharedPromiseRepository');
require('./repository/base/baseRepository');
require('./repository/base/baseSharedPromiseRepository');

require('./services/loadingBarHandler');
require('./services/persistentConnection');
require('./services/alert/alertHandler');
require('./services/alert/alertRegistrationRepository');

require('./sessionTimeout/sessionTimeout.tpl.html');
require('./sessionTimeout/sessionTimeoutComponent');
require('./sessionTimeout/sessionTimeoutController');

require('./util/watchers/uiWatcherManager');
require('./util/watchers/watchCounterUtil');

require('./util/attachmentUtil');
require('./util/browserUtil');
require('./util/cryptoUtil');
require('./util/currencyUtil');
require('./util/dataSetUtil');
require('./util/dateUtil');
require('./util/fileExportUtil');
require('./util/formatUtil');
require('./util/functionActionUtil');
require('./util/sortUtil');
require('./util/uuidUtil');
require('./util/xmlUtil');
require('./util/configuredFileUtil');
require('./util/formSummaryGridUtil');

require('./keepAlive/keepAliveComponent');

require('./ui/actionButtonsBar/actionButtonsBar.i18n.json');
require('./ui/actionButtonsBar/actionButtonsBar.tpl.html');
require('./ui/actionButtonsBar/actionButtonsBarComponent');
require('./ui/actionButtonsBar/actionButtonsBarController');
require('./ui/actionButtonsBar/actionHandler');

require('./ui/advancedFilter/advancedFilter.i18n.json');
require('./ui/advancedFilter/advancedFilterMediator');
require('./ui/advancedFilter/advancedFilterModel');
require('./ui/advancedFilter/advancedFilterSplitterFilter');
require('./ui/advancedFilter/advancedFilterType');
require('./ui/advancedFilter/filterRepository');
require('./ui/advancedFilter/yesNoFilter');

require('./ui/advancedFilter/component/advancedFilterList/advancedFilterList.tpl.html');
require('./ui/advancedFilter/component/advancedFilterList/advancedFilterListComponent');
require('./ui/advancedFilter/component/advancedFilterList/advancedFilterListController');

require('./ui/advancedFilter/component/checkboxFilter/checkboxFilter.tpl.html');
require('./ui/advancedFilter/component/checkboxFilter/checkboxFilterComponent');
require('./ui/advancedFilter/component/checkboxFilter/checkboxFilterController');

require('./ui/advancedFilter/component/dateFilter/dateFilter.tpl.html');
require('./ui/advancedFilter/component/dateFilter/dateFilterComponent');
require('./ui/advancedFilter/component/dateFilter/dateFilterController');

require('./ui/advancedFilter/component/dateFilter/dateRange/dateRange.tpl.html');
require('./ui/advancedFilter/component/dateFilter/dateRange/dateRangeComponent');
require('./ui/advancedFilter/component/dateFilter/dateRange/dateRangeController');

require('./ui/advancedFilter/component/selectFilter/selectFilter.tpl.html');
require('./ui/advancedFilter/component/selectFilter/selectFilterComponent');
require('./ui/advancedFilter/component/selectFilter/selectFilterController');

require('./ui/advancedFilter/component/textInputFilter/textInputFilter.tpl.html');
require('./ui/advancedFilter/component/textInputFilter/textInputFilterComponent');
require('./ui/advancedFilter/component/textInputFilter/textInputFilterController');

require('./ui/advancedFilter/component/typeAheadFilter/typeAheadFilter.tpl.html');
require('./ui/advancedFilter/component/typeAheadFilter/typeAheadFilterComponent');
require('./ui/advancedFilter/component/typeAheadFilter/typeAheadFilterController');

require('./ui/advancedFilter/component/unselectedFilter/unselectedFilter.tpl.html');
require('./ui/advancedFilter/component/unselectedFilter/unselectedFilterComponent');
require('./ui/advancedFilter/component/unselectedFilter/unselectedFilterController');

require('./ui/advancedFilter/component/yesNoFilter/yesNoFilter.tpl.html');
require('./ui/advancedFilter/component/yesNoFilter/yesNoFilterComponent');
require('./ui/advancedFilter/component/yesNoFilter/yesNoFilterController');

require('./ui/advancedFilter/saveAs/saveFilterAsModal.tpl.html');
require('./ui/advancedFilter/saveAs/saveFilterAsModalController');

require('./ui/attachmentViewer/attachmentViewer');
require('./ui/attachmentViewer/attachmentViewer.tpl.html');

require('./ui/attachmentViewer/attachmentViewer');
require('./ui/attachmentViewer/attachmentViewer.tpl.html');

require('./ui/avatar/uiUserAvatar');
require('./ui/avatar/uiUserAvatar.tpl.html');

require('./ui/collapsibleLeftNav/collapsibleLeftNav.tpl.html');
require('./ui/collapsibleLeftNav/collapsibleLeftNavComponent');
require('./ui/collapsibleLeftNav/collapsibleLeftNavController');

require('./ui/collapsibleLeftNav/accordionButton/accordionButton.tpl.html');
require('./ui/collapsibleLeftNav/accordionButton/accordionButtonComponent');
require('./ui/collapsibleLeftNav/accordionButton/accordionButtonController');

require('./ui/columnSort/gridSortableHeader.tpl.html');
require('./ui/columnSort/sortIcons.tpl.html');
require('./ui/columnSort/uiGridSortableHeader');
require('./ui/columnSort/uiSortIcons');

require('./ui/grid/baseGridWidgetController');
require('./ui/grid/gridColumnConstant');
require('./ui/grid/gridPaging/gridPaging.tpl.html');
require('./ui/grid/gridPaging/uiGridPaging');
require('./ui/grid/multiSelect/uiSubmissionGridMultiSelect');

require('./ui/iconViewer/iconViewer.tpl.html');
require('./ui/iconViewer/iconViewerComponent');
require('./ui/iconViewer/iconViewerController');

require('./ui/loader/uiLoader');
require('./ui/loader/uiLoader.tpl.html');

require('./ui/loadingBar/loadingBar.tpl.html');
require('./ui/loadingBar/loadingBarComponent');
require('./ui/loadingBar/loadingBarController');

require('./ui/modal/modal.tpl.html');
require('./ui/modal/modalController');
require('./ui/modal/modalUtil');
require('./ui/modal/umModalUtil');

require('./ui/modal/baseModal/baseModal.tpl.html');
require('./ui/modal/baseModal/baseModalComponent');
require('./ui/modal/baseModal/baseModalController');

require('./ui/modal/commentsModal/commentsModal.tpl.html');
require('./ui/modal/commentsModal/commentsModalController');

require('./ui/modal/emailModal/emailModal.tpl.html');
require('./ui/modal/emailModal/emailModalController');

require('./ui/modal/errorModal/errorModal.tpl.html');
require('./ui/modal/errorModal/errorModalController');

require('./ui/modal/serverDisconnectedModal/serverDisconnectedModal.tpl.html');
require('./ui/modal/serverDisconnectedModal/serverDisconnectedModalController');

require('./ui/modal/sessionTimeoutModal/sessionTimeoutModal.tpl.html');
require('./ui/modal/sessionTimeoutModal/sessionTimeoutModalController');

require('./ui/modal/userProfileModal/userProfileModal.tpl.html');
require('./ui/modal/userProfileModal/userProfileModalController');

require('./ui/multiSelect/multiSelect.tpl.html');
require('./ui/multiSelect/multiSelectComponent');
require('./ui/multiSelect/multiSelectController');
require('./ui/multiSelect/multiSelectPopup.tpl.html');
require('./ui/multiSelect/multiSelectPopupDirective');

require('./ui/notification/notification.tpl.html');
require('./ui/notification/notificationComponent');
require('./ui/notification/notificationController');
require('./ui/notification/notificationConstant');
require('./ui/notification/notificationModel');
require('./ui/notification/notificationPopupUtil');
require('./ui/notification/growl/growl.tpl.html');
require('./ui/notification/growl/growlComponent');
require('./ui/notification/growl/growlComponent.tpl.html');
require('./ui/notification/growl/growlController');
require('./ui/notification/notificationGrowl/notificationGrowl.tpl.html');
require('./ui/notification/notificationGrowl/notificationGrowlComponent');
require('./ui/notification/notificationGrowl/notificationGrowlComponent.tpl.html');
require('./ui/notification/notificationGrowl/notificationGrowlController');
require('./ui/notification/repository/notificationPreferenceRepository');
require('./ui/notification/repository/notificationRepository');

require('./ui/organization/organizationRepository');

require('./ui/requiredIndicator/uiRequiredIndicator');
require('./ui/requiredIndicator/uiRequiredIndicator.tpl.html');

require('./ui/user/userMediator');
require('./ui/user/userModule');
require('./ui/user/userRepository');
require('./ui/user/userStateModel');
require('./ui/user/userUtil');
require('./ui/user/userTypeConstant');

require('./ui/user/dropdown/userAccess/userAccessButton.tpl.html');
require('./ui/user/dropdown/userAccess/userAccessButtonComponent');
require('./ui/user/dropdown/userAccess/userAccessButtonController');

require('./ui/user/list/userList.tpl.html');
require('./ui/user/list/userListActionMediator');
require('./ui/user/list/userListActionRepository');
require('./ui/user/list/userListActionsUtil');
require('./ui/user/list/userListController');

require('./ui/user/manage/formSetMediator');
require('./ui/user/manage/formSetRepository');
require('./ui/user/manage/manageUser.tpl.html');
require('./ui/user/manage/manageUserController');
require('./ui/user/manage/userActionRepository');
require('./ui/user/manage/userActionsMediator');
require('./ui/user/manage/userActionUtil');
require('./ui/user/manage/formViewer/manageUserFormViewer.tpl.html');
require('./ui/user/manage/formViewer/manageUserFormViewerController');

require('./ui/user/menu/userMenu.tpl.html');
require('./ui/user/menu/userMenuComponent');
require('./ui/user/menu/userMenuController');

require('./ui/user/paging/gridPaging.tpl.html');
require('./ui/user/paging/gridPagingComponent');
require('./ui/user/paging/gridPagingController');

require('./ui/userGroupsBrowser/userGroupsBrowser.tpl.html');
require('./ui/userGroupsBrowser/userGroupsBrowserRepository');
require('./ui/userGroupsBrowser/userGroupsBrowserController');

require('./ui/userGroupEditor/userGroupEditor.tpl.html');
require('./ui/userGroupEditor/userGroupEditorRepository');
require('./ui/userGroupEditor/userGroupEditorController');

require('./ui/widget/baseWidgetController');

require('./ui/dropdown/dropdownComponent');

require('./ui/toggleButton/toggleButtonComponent');

module.exports = 'umCore';
